import {TYPES} from './audit-action-type.constants';
import {IDS} from './audit-action-id.constants';
import * as FORM from '../../../common/form/input/input.constants';
import {GridReducer} from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import {getAvailableYearsRange} from '../../../reducers/accreditation.reducer';
import get from 'lodash/get';
import set from 'lodash/set';
import merge from 'lodash/merge';

/**
 * @function AuditReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function AuditReducer(state, action) {

    if (typeof state === 'undefined') {
        const currentYear = new Date().getFullYear();
        return {
            headOfficeFiscalYearStart: null,
            siteLocation: {
                uuid: null,
                locationName: null,
                fiscalYearStart: null,
                autocompleteAuditors: [],
            },
            schedule: {
                fiscalYear: currentYear,
                monthColumns:       [],
                sectionRows:       [],
            },
            addAudit: {
                availableYears: getAvailableYearsRange(currentYear),
                sectionsTree: [],
                level1Requirements: [],
                level2Requirements: [],
                level3Requirements: [],
                level1RequirementId: null,
                level2RequirementId: null,
                level3RequirementId: null,
                preselectedRequirement: null,
            },
            addAuditRequirementsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    limit: 100,
                    path: IDS.addAuditRequirementsGrid,
                    // scheme_code: null,
                    // loc_uuid: null,
                    // slo_uuid: null,
                    // year_start: null,
                    // year_end: null,
                    // requirement_id: null,
                    // section_parent_id: null,
                    // requirement_level: null,
                }
            },
            // selectCascadeSections: {
            //     level1Sections: [],
            //     level2Sections: [],
            //     level3Requirements: [],
            //     level1RequirementId: null,
            //     level2RequirementId: null,
            //     level3RequirementId: null,
            // },
            sectionDetails: {
                id:         null,
                level:      null,
                nodeName:   null,
                prefix:     null, //number
                siblings:   null, //node.children.map(item => parseInt(item.number.split('.').pop())),
            },
            details: {
                activities: null,
                preselectedRequirement: null,
                requirementId: null,
                requirementParentId: null,
                requirementEvidenceDate: null,
                requirementAuditDate: null,
                sectionName: null,
                sectionLevel: null,
                sourceTab: null,
                evidenceOwner: null,
                selectedAuditor: null,

                //review
                name: null,
                description:null,
                date: null,
                auditors: [],
            },
        }
    }

    switch (action.type) {
        case TYPES.RESET_ADD_AUDIT_FIELDS:
            if (action.id === IDS.addAudit) {
                state = set({...state}, 'details.auditRequestId', null);
                set(state, 'details.date', null);
                set(state, 'details.auditors', []);
                set(state, 'details.selectedAuditor', null);
                set(state, 'details.evidenceProvider', null);
                set(state, "addAudit.level1Requirements", []);
                set(state, "addAudit.level2Requirements", []);
                set(state, 'addAudit.level3Requirements', []);
                set(state, 'addAudit.level1RequirementId', null);
                set(state, 'addAudit.level2RequirementId', null);
                set(state, 'addAudit.level3RequirementId', null);
                // set(state, 'details.evidenceProviders', []);
                // set(state, 'details.evidenceProviderFirstName', null);
                // set(state, 'details.qualityManagerLastName', null);
                // set(state, 'details.qualityManagerEmail', null);
                // set(state, 'details.autocompleteEvidenceProviders', []);
                return state
            }
        case TYPES.RESET_ADD_AUDIT_ASSIGNEES:
            if (action.id === IDS.addAudit) {
                state = set({...state}, 'details.auditRequestId', null);
                set(state, 'details.auditors', []);
                set(state, 'details.selectedAuditor', null);
                // set(state, 'details.evidenceProviders', []);
                // set(state, 'details.evidenceProviderFirstName', null);
                // set(state, 'details.qualityManagerLastName', null);
                // set(state, 'details.qualityManagerEmail', null);
                // set(state, 'details.autocompleteEvidenceProviders', []);
                return state
            }
        case TYPES.FETCH_HEAD_OFFICE_DETAILS:
            if (action.id === IDS.addAudit) {
                return { ...state,
                    headOfficeDetails: {...action.data},
                    headOfficeFiscalYearStart: action.data.fiscalYearStart
                };
            }
        case TYPES.FETCH_SITE_LOCATION_DETAILS:
                return { ...state,
                    siteLocation: { ...state.siteLocation,  ...action.siteLocation }
                };
        case TYPES.SELECT_NEW_AUDIT_FISCAL_YEAR:
                return { ...state,
                    siteLocation: {...state.siteLocation, maxDueDate: action.maxDueDate},
                    details: {...state.details, date: null}
                };
        case TYPES.SET_AUDIT_DUE_DATE:
            state = set({...state}, 'details.requirementAuditDate', action.date);
            return set(state, 'details.date', action.date);
        case TYPES.SET_REQUIREMENT_APPLICABILITY:
            return set(state, 'schedule.sectionRows', get(state, 'schedule.sectionRows').map(item => {
                if (item.id === action.requirementId) {
                    return {...item,
                        disabled: action.disabled,
                        status: action.disabled ? 'not_applicable' : null,
                    }
                }
                return item;
            }));
        case TYPES.FETCH_SITE_CONTACT_CANDIDATES:
                return  set({...state}, 'siteLocation.autocompleteAuditors', action.autocompleteAuditors);
        case TYPES.FETCH_SCHEDULE:
            if (action.id === IDS.accAudit) {
                state = set({...state}, 'schedule.monthColumns',    action.monthColumns)
                set(            state,  'schedule.sectionRows',     action.sectionRows)
                return set(     state,  'schedule.fiscalYear',      action.currentFiscalYear)
            }
        case TYPES.RESET_SCHEDULE:
            if (action.id === IDS.accAudit) {
                state = set({...state}, 'schedule.monthColumns', [])
                set(            state,  'schedule.sectionRows', [])
                set(            state,  'siteLocation.fiscalYearStart', null)
                return set(     state,  'schedule.fiscalYear', null)
            }

        case TYPES.REMOVE_AUDIT_ASSIGNEE:
            return set({...state}, action.path, get(state, action.path).filter(
                item => item !== action.item
            ))

        case TYPES.RESET_EVIDENCE_PROVIDER:
            return set({...state}, 'details.evidenceProvider', null)

        case TYPES.PRESELECT_REQUIREMENT_FOR_NEW_AUDIT:
            return set({...state}, 'addAudit.preselectedRequirement', action.requirementId);
        case TYPES.REFRESH_AUDIT_DETAILS:
            if (action.id === IDS.accAudit) {
                return set({...state}, 'details', {...action.data,
                    evidenceOwnerCandidates: [],
                    selectedEvidenceProvider: null,
                    selectedAuditor: null,
                })
            }
        case TYPES.ADD_AUDIT_ASSIGNEE:
            if (action.id === IDS.accAudit) {
                state = set({...state}, action.path, get(state, action.path).concat([action.item]))
                return merge(state, {details: {
                    selectedAuditor: null,
                }});
            }
        case TYPES.SELECT_NEW_AUDIT_REQUIREMENT:
            if (action.id === IDS.accAudit) {
                state = {...state};
                if(action.level < 3) {
                    state = set(state,
                        `addAudit.level${action.level + 1}Requirements`,
                        action.requirements.map(item => ({
                            value: item.id,
                            label: item.name,
                            disabled: item.disabled,
                        }))
                    )
                    set(state, 'addAudit.level3RequirementId', null)
                }
                let name = '';
                let requirementId = null;
                let requirementParentId = null;
                let activities = []; // all requirement ids for which evidence task will be created
                switch(action.level){
                    case 1:
                        const firstChild = get(action.requirements,'[0]');
                        name = firstChild.name;
                        requirementId = firstChild.id;
                        activities = firstChild.children.map(item => item.id);
                        requirementParentId = action.requirementId;
                        set(state, 'addAudit.level2RequirementId', requirementId);
                        set(state, 'addAudit.level3Requirements',
                            firstChild.children.map(item => ({
                                value: item.id,
                                label: item.name,
                            }))
                        )
                    break;
                    case 2:
                        name = action.name;
                        requirementId = action.requirementId;
                        activities = action.requirements.map(item => item.id);
                        requirementParentId = action.requirementParentId;
                        set(state, 'addAudit.level3Requirements',
                            action.requirements.map(item => ({
                                value: item.id,
                                label: item.name,
                            }))
                        )
                    break;
                    case 3:
                        name = action.name;
                        requirementId = action.requirementId;
                        activities = [action.requirementId];
                        requirementParentId = action.requirementParentId;
                    break;
                }
                set(state, 'details.activities', activities);
                set(state, 'details.requirementId', requirementId);
                set(state, 'details.requirementParentId', requirementParentId);

                return set(state, 'details.name', name);
            }

        /* GENERIC TYPES */

        case 'LOCATION_SELECTED':
            if(action.id === IDS.accAudit) { // slo select-cascade
                return set({...state}, 'siteLocation', action)
            }
        case 'AUTOCOMPLETE_SELECTED':
            if (action.id === IDS.accAudit && action.item) {
                return set({...state}, action.path, action.item)
            }
        case FORM.INPUT_SELECT:
        case FORM.INPUT_TEXT:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
        case 'INPUT_EMAIL_CHANGE':
        case 'INPUT_PHONE_CHANGE':
        case 'INPUT_TEXT_AREA_CHANGE':
        case 'INPUT_SIGNATURE':
            if (action.id === IDS.accAudit) { //for fiscalYear
                return set({...state}, action.path, action.input)
            }
        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if (action.id === IDS.accAudit) {
                return set({...state}, action.path,
                    GridReducer( get(state, action.path), action)
                )
            }
        case GRID.GRID_RESET:
            if (action.id === IDS.accAudit) {
                return set({...state}, action.path,
                    GridReducer( get(state, action.path),{
                        type: GRID.GRID_RESET_FILTER,
                        exclude: action.exclude /*|| (action.path === IDS.documentAddGrid ? ['slo_uuid','doc_type_code','assignedDocIds'] : [])*/,
                    })
                )
            }
        default:
            return state;
    }
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};
